// « Fiche complète à X % » : la jauge, puis chaque manque avec un lien vers l'onglet du carnet qui le complète.
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { COL } from "./shared";

export default function CompletudeCard({ completude, className = "" }) {
  const navigate = useNavigate();
  if (!completude) return null;
  const { pourcentage, rubriques_remplies, rubriques_total, manquants } = completude;
  const couleur = pourcentage >= 80 ? COL.green : pourcentage >= 50 ? "#C08A1E" : COL.amber;
  return (
    <section className={`bg-white rounded-2xl border p-4 ${className}`} style={{ borderColor: COL.line }} data-testid="fiche-completude">
      <div className="flex items-baseline justify-between gap-2">
        <h2 className="text-base font-bold" style={{ color: COL.text, fontFamily: "Manrope, sans-serif" }}>
          Fiche complète à <span style={{ color: couleur }}>{pourcentage} %</span>
        </h2>
        <span className="text-xs text-gray-500">{rubriques_remplies}/{rubriques_total} rubriques</span>
      </div>
      <div className="h-2 rounded-full mt-2 mb-3" style={{ background: "#EEECE8" }}>
        <div className="h-2 rounded-full" style={{ width: `${pourcentage}%`, background: couleur }} />
      </div>
      {manquants.length === 0 ? (
        <p className="text-sm" style={{ color: COL.green }}>Rien ne manque.</p>
      ) : (
        <ul className="divide-y" style={{ borderColor: COL.line }}>
          {manquants.map((m, i) => (
            <li key={`${m.code}-${i}`} className="flex items-center justify-between gap-3 py-1.5">
              <span className="text-sm" style={{ color: COL.text }}>{m.libelle}</span>
              {m.action ? (
                <button type="button" onClick={() => navigate(m.action.lien)}
                  className="shrink-0 min-h-[44px] px-2 text-sm font-semibold flex items-center gap-0.5"
                  style={{ color: COL.green }} data-testid={`fiche-completer-${m.code}`}>
                  Compléter <ChevronRight className="w-4 h-4" />
                </button>
              ) : <span className="shrink-0 text-xs text-gray-400">automatique</span>}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
